import { useContext } from "react";
import { RoomContext } from "./context";

const useRoom = () => {
	return useContext(RoomContext);
};

export default useRoom;
